import React from 'react';

const CsStatsPageOne = () => {
  return <div>Cs Page One</div>;
};
export default CsStatsPageOne;
